// @ts-strict-ignore
import type { WorkflowInfo } from '~/dashboard/views/workflows/store/engine/types';

const canSaveToWorkflow = (
  currentWorkflow: WorkflowInfo, comparingWorkflow: WorkflowInfo,
) => {
  if (comparingWorkflow.archived) return false;
  if (comparingWorkflow.application_token === currentWorkflow.application_token) return false;

  // SKU encodes (use_case, entity_type, application_type, is_portfolio).
  // When both workflows have a SKU, require a strict match.
  const currentSku = currentWorkflow.workflow_sku_id;
  const comparingSku = comparingWorkflow.workflow_sku_id;
  if (currentSku != null && comparingSku != null) {
    return currentSku === comparingSku;
  }

  // Legacy fallback: at least one workflow predates the SKU model. The best
  // signal we have is the legacy ApplicationTypes title.
  return currentWorkflow.type === comparingWorkflow.type;
};

export function buildSaveToAWorkflowOptions(
  currentWorkflow: WorkflowInfo, allWorkflows: WorkflowInfo[],
) {
  return [...allWorkflows]
    .filter(workflow => canSaveToWorkflow(currentWorkflow, workflow))
    .sort((workflow1, workflow2) => (workflow1.name.localeCompare(workflow2.name)))
    .map(workflow => ({
      label: workflow.name,
      meta: { type: workflow.type },
      value: workflow.application_token,
    }));
}
